var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require('react');
var createReactClass = require('create-react-class');
var CheckBoxList = require('../field-types/select/checkBoxList.jsx');
var TextAreaInput = require('../field-types/text/textAreaInput.jsx');
var TextInput = require('../field-types/text/textInput.jsx');
var Matrix = require('../field-types/matrix/matrix.jsx');
var DurationPicker = require('../field-types/pickers/durationPicker.jsx');
var ShortDurationPicker = require('../field-types/pickers/shortDurationPicker.jsx');
var Callout = require('../../../components/callout.jsx');
var AgePicker = require('../field-types/pickers/agePicker.jsx');
var HeightPicker = require('../field-types/pickers/heightPicker.jsx');
var WeightPicker = require('../field-types/pickers/weightPicker.jsx');
var StatePicker = require('../field-types/pickers/statePicker.jsx');
var Transition = require('../field-types/text/transition.jsx');

var Question = createReactClass({

    componentDidMount: function(){
        var isSubmitBlocked = false;

        $(document).on('keyup.SurveyNextQuestion', function(event){
            if(event.which === 13 && !isSubmitBlocked){ // Press 'Enter', go next question
                this.props.handleSubmit();

                isSubmitBlocked = true;
                setTimeout(function(){
                    isSubmitBlocked = false;
                }, 500)
            }
        }.bind(this));
    },

    componentWillUnmount: function(){
        $(document).off('keyup.SurveyNextQuestion');
    },

    handlePreviousQuestion: function(){
        this.props.goPreviousSurveyState();
    },

    handleResponse: function(value) {
        this.props.handleResponse(value)
    },

    renderElement: function(field) {
        var components = {
            'select': CheckBoxList,
            'select-with-image': CheckBoxList,
            // 'select-belly-pain-region': CheckBoxList, // type pre-changed to 'select-with-image' in actions/surveys-fetch.js
            'text': TextAreaInput,
            'text-input': TextInput,
            'number-input': TextInput,
            'duration-picker': DurationPicker,
            'matrix': Matrix,
            'time-picker': DurationPicker,
            'period-picker': ShortDurationPicker,
            'age-picker': AgePicker,
            'height-picker': HeightPicker,
            'weight-picker': WeightPicker,
            'state-picker': StatePicker,
            'transition': Transition
            // date time-matrix
        };

        var ItemComponent = components[field.type];
        return <ItemComponent {...field} response={this.handleResponse} currentResponse={this.props.responses.currentResponse} priorResponse={this.props.priorResponse}/>;
    },

    getSurveyTitle: function(){
        var surveyTitle = '';

        switch (this.props.surveyType) {
            case 'myqol':
                surveyTitle = 'Quality of Life Survey';
            break;

            case 'gihistory':
                surveyTitle = 'Doctor Visit Prep Survey';
            break;

            case 'nhs2':
                surveyTitle = 'National Health Survey';
            break;            

            default:
                surveyTitle = 'Gi Survey';
        }

        return surveyTitle;
    },

    render: function(){
        var field = this.props.field;
        var validationError = this.props.responses.error;
        var debug = false;
        const { label = '' } = field;

        return (
            <div className="content fadeIn animated">
                {Object.keys(validationError).length !== 0 &&
                    <div className="row">
                        <div className="column">
                            <Callout type="alert" message={validationError.message} handleClose={this.props.clearResponseValidationError} />
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="column">
                        <h1>{this.getSurveyTitle()}</h1>
                        {(debug) && <h4>{field.name}</h4>}
                        <div className={'progress-stage-indicator stage-at-' + Math.floor(this.props.progress/25)}>
                            <span className="stage stage-1"></span>
                            <span className="stage stage-2"></span>
                            <span className="stage stage-3"></span>
                            <span className="stage stage-4"></span>
                        </div>
                        <h2>{field.prelabel && <em>{field.prelabel} </em>}<span dangerouslySetInnerHTML={{ __html: label }} /> {field.sublabel && <em>{field.sublabel}</em>}</h2>
                        {this.renderElement(field)}
                        <div className="actions">
                            {this.props.responses.submission.length > 0 &&
                                <button className="go-back-btn button" onClick={this.handlePreviousQuestion}>Go Back</button>
                            }
                            <button className="button" onClick={this.props.handleSubmit}>Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = Question;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/layout/question.jsx